<template>
    <div class="dd-item dd-item--has-img">
        <span>{{ item.name }}</span>
        <img v-if="item.image" :src="item.image.thumb" :alt="item.name">
    </div>
</template>

<script>
    export default {
        props: {
            item: {required: true},
            searchText: {required: true}
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/search/itemTemplate.vue